export default __webpack_public_path__ + "static/media/Deceiver's Tunic of the Dusk Rebellion.ab379b8c.jpg";